export default "__VITE_ASSET__s$Y19rCK__"